// extracted by mini-css-extract-plugin
export default {"bg":"innerPageHeader_bg__6v1X0"};